<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                <app-reactive-form-builder (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()"
                    [form]="form.formFields" [serverUrl]="form.env.auxServerUrl"
                    [dropdownLoadTrigger]="dropdownLoadTrigger" [id]="(getModel().id)?.toString() ?? ''"
                    [dropdownsFinalized]="dropdownsFinalized"
                    [request]="this.getType() === 1 ? this.tareasApi.planAbonado.PUT : this.tareasApi.planAbonado.POST"
                    [getRequest]="this.tareasApi.planAbonado.GET">
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <form [formGroup]="comunidadForm" class="p-fluid" (ngSubmit)="saveNewOption()">

    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="this.form.openDialog=false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>